import { render } from "./myAfterSales.vue?vue&type=template&id=5d70dfbf&scoped=true"
import script from "./myAfterSales.vue?vue&type=script&lang=js"
export * from "./myAfterSales.vue?vue&type=script&lang=js"

import "./myAfterSales.vue?vue&type=style&index=0&id=5d70dfbf&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d70dfbf"]])

export default __exports__